import { useEffect, useState } from 'react';
import { adminApi } from '../../adminApi';
import { IconMail, IconArrowRight } from '../../components/Icon';
import { AdminHeader, Reveal } from './ui';

export default function AdminContacts() {
  const [rows, setRows] = useState<any[]>([]);
  const load=()=> { void adminApi.contacts().then(r=>{ if(r.status===200) setRows(r.data?.contacts||[]); }); };
  useEffect(()=>{ load(); },[]);
  return (
    <div>
      <AdminHeader icon={IconMail} title="Contact Inbox" subtitle={<span className="inline-flex items-center gap-1">Public form <IconArrowRight width={12} height={12} /> Telegram bridge. Reply via Telegram <code>/r</code> or email directly.</span>} />
      <div className="grid gap-4">
        {rows.map((c:any,i:number)=><Reveal key={c.id} i={i} className="glass p-6">
          <div className="flex flex-wrap items-center justify-between gap-2">
            <div className="font-semibold">{c.name} <span className="text-xs text-[color:var(--color-ink-faint)]">{c.email}</span></div>
            <div className="text-xs text-[color:var(--color-ink-faint)]">#{c.id} · {String(c.created_at).slice(0,16)} · {c.ip}</div>
          </div>
          {c.subject && <div className="text-xs uppercase tracking-widest text-[color:var(--color-brand-glow)] mt-1">{c.subject}</div>}
          <div className="text-sm text-[color:var(--color-ink-dim)] mt-2 whitespace-pre-wrap leading-relaxed">{c.body}</div>
          <div className="flex gap-2 mt-3">
            <a href={`mailto:${c.email}?subject=Re:%20${encodeURIComponent(c.subject||'Vpnee')}`} className="btn btn-ghost !py-1 !text-xs">Reply via email</a>
            <span className="text-xs text-[color:var(--color-ink-faint)] py-1">or reply in Telegram to the forwarded message</span>
          </div>
        </Reveal>)}
        {rows.length===0 && <div className="glass p-12 text-center text-sm text-[color:var(--color-ink-faint)]">No contacts yet</div>}
      </div>
    </div>
  );
}
